export default __webpack_public_path__ + "static/media/frame_vi_sp-landscape.08ff50f5.png";